import { FormattedMessage } from 'react-intl'
import {KTSVG} from '../../../../../../_metronic/helpers'
import {useListView} from '../../core/ListViewProvider'
import {HawalasListFilter} from './HawalasListFilter'

const HawalasListToolbar = () => {
  const {setItemIdForUpdate} = useListView()
  const openAddHawalaModal = () => {
    setItemIdForUpdate(null)
  }

  return (
    <div className='d-flex justify-content-end' data-kt-hawala-table-toolbar='base'>
      <HawalasListFilter />

      {/* begin::Export */}
      <button type='button' className='btn btn-light-primary me-3'>
        <KTSVG path='/media/icons/duotune/arrows/arr078.svg' className='svg-icon-2' />
        <FormattedMessage id='TABLE.GENERAL.EXPORT' />      </button>
      {/* end::Export */}

      {/* begin::Add hawala */}
      {/* <button type='button' className='btn btn-primary' onClick={openAddHawalaModal}>
        <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-2' />
        <FormattedMessage id='HAWALA.TABLE.CREATEHAWALA' />
      </button> */}
      {/* end::Add hawala */}
    </div>
  )
}

export {HawalasListToolbar}
